// extracted by mini-css-extract-plugin
module.exports = {"container":"AboutPage_container__rBJ6N","content":"AboutPage_content__1T0ng","idea":"AboutPage_idea___ijW0","ideal":"AboutPage_ideal__2G76v","writer":"AboutPage_writer__L6hgJ"};